import { css } from '@emotion/css';

const inputWrapper = css`
  .MuiInputBase-root {
    &.Mui-error {
      fieldset {
        border-color: var(--colors-error-900);
      }
    }
  }
`;

const errorWrapper = css`
  color: var(--colors-error-900);
`;

const TaxIdInputStyles = {
  inputWrapper,
  errorWrapper,
};

export default TaxIdInputStyles;
